<template>
  <div>
    <CourseNumberField
      v-if="isEditing"
      :label="$t('course.courseDetails.coursePrice')"
      :value="trainingPrice"
      @update:value="trainingPrice = $event"
      :isEditing="isEditing"
      :isFloat="true"
      css-class="subtitle-2 font-weight-regular textLight--text mb-3 text-start"
      :class="isEditing ? 'mb-6' : ''"
    />

    <v-btn
      v-else
      depressed
      class="subtitle-1 font-weight-regular textLight--text text-capitalize"
      style="background-color: rgba(147, 115, 255, 0.35)"
    >
      {{ $t("course.courseDetails.coursePrice") }}:
      {{ `${trainingPrice} ${$store.getters.currency}` }}
    </v-btn>
  </div>
</template>

<script>
import CourseNumberField from "@/app/course-module/components/course-details/CourseNumberField";

export default {
  name: "CoursePrice",
  components: { CourseNumberField },
  props: {
    training: {
      type: Object,
      required: true,
    },
    isEditing: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    trainingPrice: {
      get() {
        return this.training.price ?? "";
      },
      set(value) {
        this.$emit("update:training", {
          ...this.training,
          price: value,
          hasChangesInPrice: true,
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped />
